import { atom } from "jotai"
import { AuthUserProfile, UserShop } from "../libs/kratos/types"

// Сессионный токен Kratos
export const sessionTokenAtom = atom(null as string | null)

// Профиль пользователя с бэкенда (с доступными магазинами)
export const userProfileAtom = atom(null as AuthUserProfile | null)

// Активный выбранный магазин кассира
export const activeShopAtom = atom(null as UserShop | null)

// Индикатор первоначальной загрузки сессии
export const authLoadingAtom = atom(true)

// Производный статус аутентификации
export const isAuthenticatedAtom = atom((get) => {
  return Boolean(get(sessionTokenAtom))
})

// Производная роль пользователя ('admin' | 'seller' и т.д.)
export const userRoleAtom = atom((get) => {
  return get(userProfileAtom)?.role || null
})

// Отображаемое имя кассира
export const userNameAtom = atom((get) => {
  const profile = get(userProfileAtom)
  if (!profile) return ""
  return profile.username || profile.email
})

// Доступные магазины пользователя
export const userShopsAtom = atom((get) => {
  return get(userProfileAtom)?.shops || []
})
